import { Grid, Box, Image, Drawer, useMantineTheme } from '@mantine/core';
import { Dispatch, FC, SetStateAction } from 'react';
import CategoryContainer from './CategoryContainer';
import { SearchIcon } from '../../assets';
import { useCategoriesWithSearchStyles } from './styles';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import GlobalSearch from '../../components/GlobalSearch';

type Props = {
  data: any;
  isLoading: boolean;
  category: {
    name: string;
    id: number;
  };
  setCategory: Dispatch<
    SetStateAction<{
      name: string;
      id: number;
    }>
  >;
  foodItemRefs: any;
};

const CategoriesWithSearch: FC<Props> = ({ data, isLoading, category, setCategory, foodItemRefs }) => {
  const { classes, cx } = useCategoriesWithSearchStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const mantinetheme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width:${mantinetheme.breakpoints.sm})`);

  return (
    <>
      <Grid p={0} m={0} mt={isMobile ? 15 : 55}>
        <Grid.Col className={cx(classes.gridCol, classes.searchGridCol)}>
          <Box style={{ width: '100%', display: 'flex', justifyContent: 'center', cursor: 'pointer' }}>
            <Image src={SearchIcon} width={40} height={40} onClick={open} />
          </Box>
        </Grid.Col>
        <Grid.Col className={cx(classes.gridCol, classes.sliderGridCol)}>
          <CategoryContainer
            data={data?.data}
            isLoading={isLoading}
            setCategory={setCategory}
            category={category}
            foodItemRefs={foodItemRefs}
          />
        </Grid.Col>
      </Grid>
      <Drawer
        opened={opened}
        position='right'
        onClose={close}
        withCloseButton={false}
        overlayProps={{ opacity: 0.5, blur: 4 }}>
        <GlobalSearch close={close} />
      </Drawer>
    </>
  );
};

export default CategoriesWithSearch;
